export const sortingDirections = {
	ASC: 'asc',
	DESC: 'desc'
};
